import * as amplitude from '@amplitude/analytics-browser';
import { privacyConsent } from './PrivacyConsentManager';

class AmplitudeProvider
{
  init( apiKey )
  {
    amplitude.init( apiKey, {
      defaultTracking: {
        formInteractions: false   // disable "Form Started" + "Form Submitted"
      },
      serverZone: 'EU',
    } );
  }

  setUserId( userId )
  {
    // Only set user ID if user has given analytics consent
    if( !privacyConsent.hasAnalyticsConsent() )
    {
      console.log( 'Analytics user ID setting skipped - no consent' );
      return;
    }

    amplitude.setUserId( userId );
  }

  track( eventName, properties = {} )
  {
    // Only track if user has given analytics consent
    if( !privacyConsent.hasAnalyticsConsent() )
    {
      console.log( 'Analytics tracking skipped - no consent:', eventName );
      return;
    }

    amplitude.track( eventName, properties );
  }

  setUserProperties( propertyData = [] )
  {
    if( !propertyData || propertyData.length == 0 )
    {
      return;
    }

    // console.log( "setUserProperties : ", propertyData );

    const amplitudeIdentify = new amplitude.Identify();

    for( let idx = 0; idx < propertyData.length; idx++ )
    {
      const userPropData = propertyData[ idx ];

      if( userPropData.field === undefined || userPropData.value === undefined )
      {
        // console.log( "skipping prop entry ", userPropData );
        continue;
      }

      if( userPropData.setOnce !== undefined && userPropData.setOnce )
      {
        amplitudeIdentify.setOnce( userPropData.field, userPropData.value );
      }
      else
      {
        amplitudeIdentify.set( userPropData.field, userPropData.value );
      }
    }

    amplitude.identify( amplitudeIdentify );
  }
}

class AnalyticsManager
{
  static instance = null;
  static initialized = false;
  static sessionUserID = undefined;

  constructor()
  {
    if( AnalyticsManager.instance )
    {
      return AnalyticsManager.instance;
    }
    this.provider = null;
    AnalyticsManager.instance = this;
  }

  setProvider( provider )
  {
    this.provider = provider;
  }

  init( apiKey )
  {
    if( !this.initialized && this.provider )
    {
      this.provider.init( apiKey );
      this.initialized = true;
    }
  }

  setUserId( userId )
  {
    // Only set user ID if user has given analytics consent
    if( !privacyConsent.hasAnalyticsConsent() )
    {
      // console.log('Analytics user ID setting skipped - no consent');
      return;
    }

    if( this.provider
      && userId !== undefined
      && ( this.sessionUserID === undefined || this.sessionUserID !== userId ) )
    {
      this.provider.setUserId( userId );

      console.log( "Set user ID: ", userId );

      this.sessionUserID = userId;
    }
  }

  track( eventName, properties = {} )
  {
    // Only track if user has given analytics consent
    if( !privacyConsent.hasAnalyticsConsent() )
    {
      console.log( 'Analytics tracking skipped - no consent:', eventName );
      return;
    }

    if( this.provider )
    {
      this.provider.track( eventName, properties );
    }
  }

  setUserProperties( propertyData = [] )
  {
    // Only set user properties if user has given analytics consent
    if( !privacyConsent.hasAnalyticsConsent() )
    {
      return;
    }

    if( !propertyData || propertyData.length == 0 )
    {
      return;
    }

    if( this.provider )
    {
      this.provider.setUserProperties( propertyData );
    }
  }
}

// Export a singleton instance
export const analytics = new AnalyticsManager();
export { AmplitudeProvider };
